import React, { useState } from 'react'
import { MachineCell, MachineInfo, MachineName, RowContainer } from '../../ProductionFlow/components-tests/MachineRow/style'
import DayCell from '../DayCell'

const MachineRow = ({ machine, weekdays, moveProductionOrder }:any) => {
    const [ productionOrders, setProductionOrders ] = useState([])

    return (
        <RowContainer>
            <MachineCell>
                <MachineName>{machine.name}</MachineName>
                <MachineInfo>ID: {machine.id}</MachineInfo>
            </MachineCell>
            {weekdays.map((day:any, index:number) => (
                <DayCell 
                    key={`${machine.id}-${day}`}
                    day={day}
                    machineOd={machine.id}
                    orders={machine.service.filter((order:any) => order.productionDay === index +1)}
                    moveProductionOrder={moveProductionOrder}
                />
            ))}
        </RowContainer>
    )
}

export default MachineRow